
export default {
  name: 'RectangleBgCard',
  props: {
    blockOptions: {
      type: Object
    }
  }
}
